import type { DescriptorEnumItem } from "@lr-notitia/notitia-model-store/schemas";
import type { Graph } from "@lr-notitia/notitia-operator/schemas";

import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const enumItems = (graph: Ref<Graph>) =>
	computed<DescriptorEnumItem[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "enum-item" && node.layer === "descriptor"
			) as DescriptorEnumItem[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology }).toLocaleLowerCase())
		);
	});

export function enumItem(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => {
			return graph.value.nodes[id] as DescriptorEnumItem | undefined;
		},
	};
}
